export const mediaListForMarkdownStyle = {
	copyButton: {
		padding: "10px 10px 5px",
		margin: "0 5px 0 0",
	},
};
